import { Box, Container } from "@mui/material";

import { HeroText } from "components/shared/Typography";
import { colors } from "theme";

import { GlobalPartners } from "./GlobalPartners";
import { OurLocations } from "./OurLocations";

export const ContactInfo = () => (
  <Box
    component="section"
    pt={{ xs: 3, md: 5, lg: 10 }}
    pb={{ xs: 4, md: 7, lg: 12 }}
    bgcolor={colors.white}
  >
    <Container>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap={{ xs: "24px", md: "32px" }}
      >
        <HeroText align="center" component="h2">
          Our locations and representatives
        </HeroText>
        <OurLocations />

        <HeroText align="center" component="h2">
          Global partners
        </HeroText>
        <GlobalPartners />
      </Box>
    </Container>
  </Box>
);
